import React from 'react';
import clsx from 'clsx';
import { Backdrop, CircularProgress, Typography } from '@material-ui/core';
import { Logo } from '@rcg/ui-react';
import Theme from '../../theme/booking-theme';
import useStyles from './index.styles';

const AirLoader = ({ display = false, message = '', hideBackground = false }) => {
  const classes = useStyles();

  return (
    <Backdrop
      data-testid="loader"
      open={display}
      className={clsx(classes.backdrop, hideBackground && classes.bgSolidWhite)}>
      <div className={classes.loaderContainer}>
        <CircularProgress className={classes.circularLoader} size="120px" thickness={1} />
        <Logo
          className={classes.loaderLogo}
          color={Theme.palette.primary.dark}
          width="42px"
          height="42px"
        />

        {message && (
          <div className={classes.loaderTitle}>
            <Typography>{message}</Typography>
          </div>
        )}
      </div>
    </Backdrop>
  );
};

export default AirLoader;
